import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accordion", "icon", "frame"];

  connect() {
    this.accordionTargets.forEach((accordion) => {
      accordion.addEventListener("click", (event) => {
        this.toggle(accordion);
      });
    })
  }

  disconnect() {
    this.accordionTargets.forEach((accordion) => {
      accordion.removeEventListener("click", (event) => {
        this.toggle(accordion);
      });
    })
  }

  toggle(event) {
    const eventResult = this.dispatch('checkDirtyForm');
    if (eventResult.defaultPrevented) return;

    const turboElement = $(`#${event.dataset.tableAccordionTurboId}`);
    const turboElementSrc = turboElement.attr('src');
    if (turboElementSrc && turboElementSrc.includes(event.dataset.tableAccordionHref)) {
      turboElement.attr('src', null);
      turboElement.empty();
      this.iconTargets.forEach((icon) => {
        icon.classList.replace("fa-chevron-down", "fa-chevron-right");
      })
      return;
    }
    turboElement.attr('src', event.dataset.tableAccordionHref);
    this.frameTargets.forEach((frame) => {
      if (frame.id !== event.dataset.tableAccordionTurboId) {
        $(frame).attr('src', null);
        $(frame).empty();
      }
    });
    const id = event.dataset.tableAccordionItemId;
    this.iconTargets.forEach((icon) => {
      if (icon.id === `${id}-icon`) {
        icon.classList.replace("fa-chevron-right", "fa-chevron-down");
      } else {
        icon.classList.replace("fa-chevron-down", "fa-chevron-right");
      }
    })
  }
}
